import React from 'react';

const sizeClasses = {
  // Matches the spinner Button renders inside itself, so an inline spinner in a
  // button looks the same whichever of the two you reach for.
  xs: 'h-4 w-4',
  small: 'h-8 w-8',
  medium: 'h-12 w-12',
  large: 'h-16 w-16'
};

// Call sites write both the long and the short form of every size.
const sizeAliases = { sm: 'small', md: 'medium', lg: 'large' };

const LoadingSpinner = ({ size = 'medium', inline = false, className = '' }) => {
  // An unrecognised size falls back to medium rather than leaving the spinner
  // with no width or height at all, which renders nothing.
  const sizeClass = sizeClasses[sizeAliases[size] || size] || sizeClasses.medium;
  const spinnerClasses = `animate-spin rounded-full ${sizeClass} border-b-2 border-primary-600`;

  // The page-level spinner reserves 16rem of height so a loading page does not
  // collapse. An inline spinner sits inside a button or an input overlay, where
  // that wrapper would stretch its container to 256px instead.
  if (inline) {
    return <div className={`inline-block ${spinnerClasses} ${className}`}></div>;
  }

  return (
    <div className={`flex justify-center items-center h-64 ${className}`}>
      <div className={spinnerClasses}></div>
    </div>
  );
};

export default LoadingSpinner;
